export enum ViewType {
	NORMAL = 0,
	INADMIN = 1
}